import './styles.scss'

import React from 'react'
import { Button } from 'reactstrap'

/**
 *
 * @param {Object} props
 * title: string
 * text: string
 * textBtn: string
 * clickBtn: Function
 */
function BannerInfoBtn({ props }) {
  const handleClick = () => {
    props.handleClick(props)
  }

  const handleHover = () => {
    if (props.handleHover) {
      props.handleHover(props)
    }
  }

  return (
    <div className={`banner-info-btn ${props.primary ? 'is-primary' : ''}`} onMouseEnter={handleHover}>
      <div className='banner-body'>
        <h1 className='banner-title'>{props.title}</h1>
        <p className='banner-text' dangerouslySetInnerHTML={{ __html: props.text }}></p>
      </div>

      <div className='banner-action'>
        <Button outline color='btn-lg' onClick={handleClick}>
          {props.textBtn}
        </Button>
      </div>
    </div>
  )
}

export default BannerInfoBtn
